// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"SentrySplash_logoWrapper__357Qy","splash":"SentrySplash_splash__jmais"};